const logo = {};
const frames = [
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSULTING</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSULTIN</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSULTI</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSULT</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSUL</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONSU</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular">CONS</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTRY</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUSTR</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUST</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUST</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDUS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">INDU</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">IND</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium">IN</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROSS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium blue">I</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CROS</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium blue">I</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CRO</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium blue">I</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold">CR</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium blue">I</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
    '\
    <div class="logo__x bold blue">X</div>\
    <div class="logo__devider"></div>\
    <div class="logo__i medium blue">I</div>\
    <div class="logo__devider"></div>\
    <div class="logo__c regular blue">CON</div>\
    ',
]
let pageHeight = 0;
let interval = 50;
let lastPageOffset = 0;
let lastAnimationOffset = 0;
let frameCount = 0;
let scrollDir = '';
let childrenWidth = [];
let lastClick = {};

window.onload = () => {
    logo.el = document.querySelector('.logo')
    lastPageOffset = pageYOffset
    pageHeight = document.body.scrollHeight - document.body.clientHeight
    interval = Math.floor(document.body.clientHeight / (frames.length * 1.5))

    menuListen()
    setLastTileHeight(document.querySelectorAll('.last-tile'))
    fixedWidth(logo.el)
    
    window.onscroll = () => {
        scrollDir = scrollDirection()
        animateLogo()
        fixedWidth(logo.el)
    }
}

// Menu Toggle
function menuListen() {
    let openMenu = document.querySelector('.menu-button__open');
    let closeMenu = document.querySelector('.menu-button__close');
    let menu = document.querySelector('.menu-overlay');

    openMenu.onclick = () => {
        menu.style.display = 'flex'
    }

    closeMenu.onclick = () => {
        menu.style.display = 'none'
    }
}

const setLastTileHeight = (lastTiles) => {
    if (document.body.offsetWidth > 720) {
        lastTiles.forEach(tile => {
            tile.style.height = tile.previousElementSibling.offsetHeight + 'px'
        });
    }
}

// Event Listener for Inputs
if (document.addEventListener) {
    document.addEventListener("click", clickHandler, false)
    document.addEventListener("wpcf7submit", cfHandler, false)
}
else if (document.attachEvent) {
    document.attachEvent("onclick", clickHandler)
}

function cfHandler(event) {
    if (event.target.dataset.onSuccess.length > 0) {
        console.log(event.target)
        let url = event.target.dataset.onSuccess
        let title = event.target.dataset.onSuccessTitle
        let filename = url.substr(url.lastIndexOf('/') + 1)
        let anchor = document.createElement('a')
        anchor.href = event.target.dataset.onSuccess
        anchor.download = filename
        anchor.dispatchEvent(new MouseEvent('click'))
        document.removeChild(anchor)
    }
}

function clickHandler(event) {
    event = event || window.event
    // event.target = event.target || event.srcElement

    if (event.target.classList.contains('form--text-input') ||
        event.target.classList.contains('form--textarea-input')
        ) {
        revealLabel(event.target)
    }

    if (event.target.dataset.olTrigger) {
        revealOverlay(event.target)
    }

    if (event.target.dataset.ol) {
        hideOverlay(event.target)
    }

    if (event.target.classList.contains('team-member--image-container') ||
        event.target.classList.contains('team-member--image') ||
        event.target.classList.contains('team-member--name')
        ) {
        revealMember(event.target)
    }

    if (event.target.classList.contains('team-member-overlay') ||
        event.target.classList.contains('team-member-overlay--close') ||
        event.target.classList.contains('team-member-overlay--close-bottom')
        ) {
        hideMember(event.target)
    }

    if (typeof lastClick.target != 'undefined') {
        if (lastClick.target.classList.contains('form--text-input') ||
            lastClick.target.classList.contains('form--textarea-input')
            ) {
            if (lastClick.target.value.length === 0) {
                hideLabel(lastClick.target)
            }

            if (lastClick.target.classList.contains('form--textarea-input')) {
                lastClick.target.style.height = '2rem'
            }
        }
    }

    lastClick = event
}

// Reveal Functions
const revealLabel = (el) => {
    el.placeholder = ''
    el.parentElement.parentElement.children[0].style.display = 'block'

    if (el.classList.contains('form--textarea-input')) {
        el.style.height = 'auto'
    }
}

const hideLabel = (el) => {
    let label = el.parentElement.parentElement.children[0]
    el.placeholder = label.innerHTML
    label.style.display = 'none';

    if(el.classList.contains('form--textarea-input')) {
        el.style.height = '100%'
    }
}

const revealOverlay = (trigger) => {
    let overlays = document.querySelectorAll('.overlay')
    overlays.forEach((currentValue, currentIndex, listObj) => {
        if (currentValue.dataset.ol === trigger.dataset.olTrigger) {
            currentValue.classList.add('active')
            currentValue.style.height = document.body.scrollHeight + 'px'
            currentValue.style.paddingTop =  pageYOffset + document.body.clientHeight * 0.2 + 'px'

            if (currentValue.contains(currentValue.querySelector('div.wpcf7'))) {
                    let cfDiv = currentValue.querySelector('div.wpcf7')
                    cfDiv.dataset.onSuccess = trigger.dataset.olFlow
                    cfDiv.dataset.onSuccessTitle = trigger.dataset.olTitle
                    cfDiv.querySelector('input[name="title"]').value = trigger.dataset.olTitle
                    cfDiv.querySelector('input[name="fileurl"]').value = trigger.dataset.olFlow
                    cfDiv.querySelector('input[name="filename"]').value = trigger.dataset.olFlow.substr(trigger.dataset.olFlow.lastIndexOf('/') + 1)
            }
        }
    })
}

const hideOverlay = (el) => {
    let overlays = document.querySelectorAll('.overlay')
    overlays.forEach((currentValue, currentIndex, listObj) => {
        if (currentValue.dataset.ol === el.dataset.ol) {
            currentValue.classList.remove('active')
        }
    })
}

const revealMember = (el) => {
    let overlays = document.querySelectorAll('.team-member-overlay');
    overlays.forEach((currentValue, currentIndex, listObj) => {
        if (currentValue.dataset.mc == el.dataset.mc) {
            currentValue.style.display = 'flex'
            currentValue.style.height = document.body.scrollHeight + 'px'
            currentValue.style.paddingTop = pageYOffset + 'px'
        }
    })
}

const hideMember = (el) => {
    if (el.classList.contains('team-member-overlay')) {
        el.style.display = 'none'
    } else {
        let overlays = document.querySelectorAll('.team-member-overlay');
        overlays.forEach((currentValue, currentIndex, listObj) => {
        if (currentValue.dataset.mc == el.dataset.mc) {
            currentValue.style.display = 'none'
        }
    })
    }
}


// Get Scroll Direction
const scrollDirection = () => {
    if (pageYOffset > lastPageOffset) {
        lastPageOffset = pageYOffset
        return 'down'
    } else if (pageYOffset < lastPageOffset) {
        lastPageOffset = pageYOffset
        return 'up'
    }
}

// Animate Logo Magic
const animateLogo = () => {
    if (scrollDir == 'down' && pageYOffset > lastAnimationOffset + interval && frameCount < frames.length - 1) {
        lastAnimationOffset = pageYOffset > interval * 2 ? pageYOffset : interval * 2
        frameCount++
        logo.el.innerHTML = frames[frameCount]
    } else if (scrollDir == 'up' && pageYOffset < lastAnimationOffset - interval && frameCount > 0) {
        lastAnimationOffset = pageYOffset > interval * 2 ? pageYOffset : interval * 2
        frameCount--
        logo.el.innerHTML = frames[frameCount]
    }

    if (pageYOffset == 0 && frameCount != 0) {
        while (frameCount != 0) {
            frameCount--
            logo.el.innerHTML = frames[frameCount]
        }
    }

    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight && frameCount != frames.length - 1) {
        while (frameCount != frames.length - 1) {
            frameCount++
            logo.el.innerHTML = frames[frameCount]
        }
    }
}

// Fixed Width for Logo Children
function fixedWidth(el) {
    if (frameCount == 0) {
        for (let i = 0; i < el.children.length; i++) {
            let node = el.children[i]
            let width = node.offsetWidth
            childrenWidth[i] = width
            node.style.width = width + 'px'
        }
    } else {
        for (let i = 0; i < el.children.length; i++) {
            let node = el.children[i]
            let width = childrenWidth[i]
            node.style.width = width + 'px'
        }

    }
}

const makeExpandingTextarea = (container) => {
    const area = container.querySelector('textarea')
    const span = container.querySelector('span')
    if (area.addEventListener) {
        area.addEventListener('input', () => {
            span.textContent = area.value
        }, false)
        span.textContent = area.value
    } else {
        area.attachEvent('onproperychange', () => {
            span.innerText = area.value
        })
        span.innerText = area.value
    }

    container.className += 'active'
}
const areas = document.querySelectorAll('form--expanding-area')
let l = areas.length
while (l--) {
    makeExpandingTextarea(areas[l])
}